import { createReducer, on } from '@ngrx/store';
import * as CommonActions from './common.actions';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface CommonState {
    all: any[] | any;
    one: any | null;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialCommonState: CommonState = {
    all: [],
    one: null,
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// All Reducer
export const commonReducer = createReducer(
    initialCommonState,

    // On Load
    on(CommonActions.loadAll, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(CommonActions.loadAllSuccess, (state, { data }) => ({
        ...state,
        isLoading: false,
        all: data,
    })),
    on(CommonActions.loadAllFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load One
    on(CommonActions.loadOne, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(CommonActions.loadOneSuccess, (state, { data }) => ({
        ...state,
        isLoading: false,
        one: data,
    })),
    on(CommonActions.loadOneFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Create
    on(CommonActions.create, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(CommonActions.createSuccess, (state, { data }) => ({
        ...state,
        isLoading: false,
        all: [...state.all, data],
    })),
    on(CommonActions.createFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Update
    on(CommonActions.update, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(CommonActions.updateSuccess, (state, { data }) => ({
        ...state,
        isLoading: false,
        all: state.all.map((item) => (item.id === data.id ? data : item)),
    })),
    on(CommonActions.updateFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Delete
    on(CommonActions.deleteCommon, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(CommonActions.deleteSuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        all: state.all.filter((item) => item.id !== id),
    })),
    on(CommonActions.deleteFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);
